import { render, staticRenderFns } from "./TradeResponseInfo.vue?vue&type=template&id=a45e5032&scoped=true"
import script from "./TradeResponseInfo.vue?vue&type=script&lang=js"
export * from "./TradeResponseInfo.vue?vue&type=script&lang=js"
import style0 from "./TradeResponseInfo.vue?vue&type=style&index=0&id=a45e5032&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a45e5032",
  null
  
)

export default component.exports